import { ROLES } from 'utils/constants'
import { adminRoutes } from './AdminRoutes'
import { counselorRoutes } from './CounselorRoutes'

const { doctorRoutes } = require('./doctorRoutes')

const protectedRoutes = ({ role }) => {
  const { COUNSELOR, DOCTOR, ADMIN } = ROLES
  switch (role) {
    case DOCTOR:
      return doctorRoutes
    case ADMIN:
      return adminRoutes
    case COUNSELOR:
      return counselorRoutes
    default:
      return []
  }
}

export default protectedRoutes
